import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79262238"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sorting_wrapper"
}

import { computed, nextTick, onMounted, PropType, ref, watch } from 'vue';
import KanbanDraggable from './KanbanDraggable.vue';
import { DragModel } from '../../models';

import '../../extensions/ArrayItemsExchange';
import { useRootFontSize } from 'tir-pm-toolkit';

/**Параметры компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'KanbanDraggableSorting',
  props: {
  /**Выкл/вкл перетаскивания */
  enabled: { default: true },
  /**Элементы для сортировки */
  data: { default: null, type: Object as PropType<DragModel<any>[]> },
  /**Функция для разрешения дропа */
  allowDropFunc: { default: null, type: Function },
  /**Поле значения (Можно использовать длинные ключи(object.object2.key)) */
  valueField: { default: '' },
  /**Длительность анимации при драге */
  animationDuration: { default: 0.2 },
  /**Велечина отступов */
  indent: { default: 5 },
  /**Использовать ли анимацию */
  isTransition: { default: false },
  /**Позволить скроллить во время драга */
  isAllowScroll: { default: false, type: Boolean },
  /**Скорость скролла при касании */
  dragScrollSpeed: { default: 10, type: Number },
  /**Класс для обертки */
  dataClass: { default: '', type: String },
  /**Включение задержки перед драгом */
  isAllowClickDelay: { default: false, type: Boolean },
  /**Отключить боковые отступы */
  disableSideIndent: { default: false, type: Boolean },
  /**Перетаскивается ли блок вне компонента */
  outerIsDrag: { default: false, type: Boolean },
  /**Флаг для очистки данных о перетаскиваемом элементе */
  cleanFlag: { default: false, type: Boolean },
  /**Отображение пустой область для дропа */
  isAllowPlug: { default: false, type: Boolean },
  /**Внешний перетаскиваемый элемент */
  outerCurrentDragging: {
    default: null,
    type: Object as PropType<DragModel<any>>,
  },
  /**DOM элемент области прокрутки */
  scrollArea: { default: null, type: HTMLElement },
},
  emits: ['change', 'added', 'dragComponentOnDrag', 'cancel'],
  setup(__props, { emit }) {

const props = __props;


/**События компонента */


const { rootFontSizePx } = useRootFontSize();

/**Данные о списке */
const innerData = ref<DragModel<any>[]>([]);
/**Текущий перетаскиваемый компонент */
const currentDragging = ref<DragModel<any>>();
/**Перетаскивается ли элемент */
const isDrag = ref<boolean>(false);
/**Элемент над которым находится перетаскиваемый */
const currentDragOver = ref<number>();
/**Index перетаскиваемого элемента */
const currentDraggingIndex = ref<number>();
/**Высота перетаскиваемого элемента */
const draggingElHeight = ref<number>();
/**Модель для drop обертки списка */
const wrapperDragModel = ref<DragModel<any>>(new DragModel());
/**DOM элемент предложения */
const $sentence = ref<HTMLDivElement[]>();

/**Атрибут name элемента transition-group */
const transitionGroupName = computed(() => (props.isTransition ? 'flip-list' : ''));
/**Стиль drag обертки компонента */
const dragWrapperStyle = computed(() => ({
  minHeight: props.isAllowPlug && !innerData.value.length ? '100%' : '',
}));
/**Поле для отслеживания изменений параметра data */
const data = computed(() => props.data);
/**Поле для отслеживания изменений параметра cleanFlag */
const cleanFlag = computed(() => props.cleanFlag);

/**Отслеживание изменений параметра data */
watch(data, onUpdateData, { deep: true });
/**Отслеживание изменений параметра cleanFlag */
watch(cleanFlag, onUpdateCleanFlag, { deep: true });

/**После рендера компонента */
onMounted(() => {
  onUpdateData();
  wrapperDragModel.value.AllowDrop = true;
});

/**Стиль drag-component элемента списка */
const dragComponentItemStyle = computed(() => ({
  margin: !props.disableSideIndent ? `0rem ${props.indent / rootFontSizePx.value}rem` : '0rem',
}));
/**Получение стилей для обертки элемента списка */
const getDragItemWrapperStyle = (index: number) => ({
  opacity: currentDraggingIndex.value == index && (isDrag.value || props.outerIsDrag) ? '0' : '',
});
/**Получение стилей для элемента списка */
const getDragItemStyle = (index: number) => ({
  margin:
    currentDraggingIndex.value == null ? `${props.indent / rootFontSizePx.value}rem 0rem` : '',
  marginLeft: '0rem',
  marginRight: '0rem',
  paddingTop:
    typeof currentDragOver.value == 'number' &&
    typeof currentDraggingIndex.value == 'number' &&
    (index <= currentDragOver.value || index == currentDragOver.value)
      ? props.indent / rootFontSizePx.value + 'rem'
      : '',
  paddingBottom:
    typeof currentDragOver.value == 'number' &&
    typeof currentDraggingIndex.value == 'number' &&
    (index >= currentDragOver.value || index == currentDragOver.value)
      ? props.indent / rootFontSizePx.value + 'rem'
      : '',
  transition: currentDraggingIndex.value != null ? `transform ${props.animationDuration}s` : '',
  transform: onTransform(index),
});
/**Очистка данных о перетаскиваемом элементе */
function onUpdateCleanFlag() {
  currentDragOver.value = undefined;
  currentDraggingIndex.value = undefined;
  currentDragging.value = undefined;
}
/**Заполнение поля innerData */
function onUpdateData() {
  innerData.value = props.data;
}
/**Получение значения объекта */
const getValue = (index: number) => {
  let value: any = innerData.value[index]?.Data;
  if (props.valueField.length) {
    let keys = props.valueField.split('.');
    for (let i = 0; i < keys.length; i++) {
      value = value[keys[i]];
    }
    return value;
  } else {
    return innerData.value[index]?.Data;
  }
};
/**Получение transform стиля */
const onTransform = (index: number) => {
  if (typeof currentDraggingIndex.value != 'number' || typeof currentDragOver.value != 'number')
    return '';

  if (currentDraggingIndex.value <= index && index <= currentDragOver.value)
    return `translateY(-${
      Number(draggingElHeight.value) / rootFontSizePx.value - props.indent / rootFontSizePx.value
    }rem)`;
  else if (currentDraggingIndex.value >= index && index >= currentDragOver.value)
    return `translateY(${
      Number(draggingElHeight.value) / rootFontSizePx.value - props.indent / rootFontSizePx.value
    }rem)`;
};
/**Получение высоты перетаскиваемого элемента, при старте перетаскивания */
const sentenceOnMouseDown = (event: any) => {
  let rect = (event.currentTarget as HTMLElement)?.getBoundingClientRect();
  draggingElHeight.value = rect?.height;
};
const sentenceOnTouchStart = (event: TouchEvent) => {
  sentenceOnMouseDown(event.touches[0]);
};
/**Перетаскивание элемента */
const dragComponentOnDrag = (isDragging: boolean, model: DragModel<any>) => {
  setTimeout(() => {
    isDrag.value = isDragging;

    if (!isDrag.value) {
      onUpdateCleanFlag();
    } else {
      let index = innerData.value.findIndex((x) => x == model);
      currentDragging.value = model;
      currentDraggingIndex.value = index;
      if (currentDragOver.value == null) currentDragOver.value = currentDraggingIndex.value;
    }
    emit('dragComponentOnDrag', isDrag.value, model);
  });
};

/**Поиск index'a элемента, над которым перетаскивается элемент */
const dragComponentOnOver = (isOver: boolean, model: DragModel<any>) => {
  if ((props.outerIsDrag || isDrag.value) && isOver)
    currentDragOver.value = innerData.value.findIndex((x) => x == model);
};
/**Обработка перетаскивания внешнего компонента над текущим */
const dragWrapperOnOver = (isOver: boolean) => {
  if (!props.outerCurrentDragging) return;
  if (props.outerCurrentDragging == currentDragging.value) {
    if (!isOver) currentDragOver.value = undefined;
    return;
  }
  if (!isOver || !props.outerCurrentDragging) {
    innerData.value = innerData.value.filter((x) => x != props.outerCurrentDragging);
    emit('cancel', innerData.value);
    currentDragOver.value = undefined;
    currentDraggingIndex.value = undefined;
  } else if (!innerData.value.find((x) => x.Data == props.outerCurrentDragging.Data)) {
    innerData.value.push(props.outerCurrentDragging);
    currentDraggingIndex.value = innerData.value.length - 1;
    setTimeout(() => {
      if (!currentDraggingIndex.value) return;
      let rect = $sentence.value?.[currentDraggingIndex.value]?.getBoundingClientRect();
      if (rect) draggingElHeight.value = rect.height;
    });
  }
};
/**Сброс слова в список */
const dragComponentOnDrop = (model: DragModel<any>) => {
  let target: DragModel<any> | null = null;
  let sourceIndex: number | null = null;
  let targetIndex: number | null = null;

  targetIndex = innerData.value.findIndex((x) => x == model);

  target = innerData.value[targetIndex];
  if (target && currentDragging.value && isDrag.value) {
    sourceIndex = innerData.value.findIndex((x) => x == currentDragging.value);

    if (sourceIndex == targetIndex) return;

    if (sourceIndex > targetIndex) {
      for (let i = sourceIndex; i > targetIndex; i--) {
        innerData.value.exchangeItems(i, i - 1);
      }
    } else {
      for (let i = sourceIndex; i < targetIndex; i++) {
        innerData.value.exchangeItems(i, i + 1);
      }
    }
    emit('change', innerData.value);
  } else if (props.outerCurrentDragging && props.outerIsDrag) {
    innerData.value = innerData.value.filter((x) => x != props.outerCurrentDragging);
    innerData.value.splice(targetIndex, 0, props.outerCurrentDragging);
    emit('added', innerData.value);
  }
  onUpdateCleanFlag();
};
/**При дропе в заглушку */
const dragWrapperOnDrop = async () => {
  if (!props.isAllowPlug) return;
  if (props.outerCurrentDragging && props.outerIsDrag) {
    innerData.value = innerData.value.filter((x) => x != props.outerCurrentDragging);
    innerData.value.push(props.outerCurrentDragging);
    emit('added', innerData.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (innerData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(KanbanDraggable, {
          class: "drag_wrapper",
          dragModel: wrapperDragModel.value,
          style: _normalizeStyle(dragWrapperStyle.value),
          onOver: dragWrapperOnOver,
          onDrop: dragWrapperOnDrop
        }, {
          default: _withCtx(() => [
            _createVNode(_TransitionGroup, { name: transitionGroupName.value }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(innerData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.Data?.TaskId || index,
                    ref_for: true,
                    ref_key: "$sentence",
                    ref: $sentence,
                    style: _normalizeStyle(getDragItemWrapperStyle(index)),
                    onMousedown: sentenceOnMouseDown,
                    onTouchstart: sentenceOnTouchStart
                  }, [
                    _createVNode(KanbanDraggable, {
                      class: "drag_component",
                      dragModel: item,
                      scrollArea: __props.scrollArea,
                      allowDropFunc: __props.allowDropFunc,
                      isAllowScroll: __props.isAllowScroll,
                      dragScrollSpeed: __props.dragScrollSpeed,
                      style: _normalizeStyle(dragComponentItemStyle.value),
                      isAllowClickDelay: __props.isAllowClickDelay,
                      enabled: __props.enabled,
                      "click-delay": 150,
                      onDragging: dragComponentOnDrag,
                      onOver: dragComponentOnOver,
                      onDrop: dragComponentOnDrop
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["data", __props.dataClass]),
                          style: _normalizeStyle(getDragItemStyle(index))
                        }, [
                          _renderSlot(_ctx.$slots, "item", {
                            item: getValue(index),
                            index: index
                          })
                        ], 6)
                      ]),
                      _: 2
                    }, 1032, ["dragModel", "scrollArea", "allowDropFunc", "isAllowScroll", "dragScrollSpeed", "style", "isAllowClickDelay", "enabled"])
                  ], 36))
                }), 128))
              ]),
              _: 3
            }, 8, ["name"])
          ]),
          _: 3
        }, 8, ["dragModel", "style"])
      ]))
    : _createCommentVNode("", true)
}
}

})